import { render, staticRenderFns } from "./scanCodeGun.vue?vue&type=template&id=212ac847&scoped=true&"
import script from "./scanCodeGun.vue?vue&type=script&lang=js&"
export * from "./scanCodeGun.vue?vue&type=script&lang=js&"
import style0 from "./scanCodeGun.vue?vue&type=style&index=0&id=212ac847&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212ac847",
  null
  
)

export default component.exports